export default __webpack_public_path__ + "static/media/PH.fcc6c793.ico";